export const MAX_IMGE_WH = 2048;
export const MIN_IMAGE_WH = 512;

export const resizeWrapperId = 'resizeWrapperId';
export const resizeInnerId = 'resizeInnerId';
